document.addEventListener('DOMContentLoaded', function () {
  var body = document.body;
  var toggleBtn = document.querySelector('[data-mobile-menu-toggle]');
  var closeBtn = document.querySelector('[data-mobile-menu-close]');
  var overlay = document.querySelector('[data-mobile-menu-overlay]');

  function open() { body.classList.add('mobile-menu-open'); }
  function close() { body.classList.remove('mobile-menu-open'); }

  if (toggleBtn) toggleBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);

  // The mobile drawer and the search overlay share the same z-index layer.
  // Whichever search trigger gets clicked (the header icon, or the one now
  // living inside this drawer), close the drawer first so the two panels
  // never end up stacked on top of each other.
  var searchTriggers = document.querySelectorAll('[data-search-toggle]');
  searchTriggers.forEach(function (btn) {
    btn.addEventListener('click', close);
  });

  var accordionToggles = document.querySelectorAll('[data-accordion-toggle]');
  accordionToggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.closest('.mobile-menu__item').querySelector('[data-accordion-panel]');
      var isHidden = panel.hidden;
      panel.hidden = !isHidden;
      btn.textContent = isHidden ? '−' : '+';
    });
  });
});